"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PostMode = void 0;

require("antd/es/col/style/css");

var _col = _interopRequireDefault(require("antd/es/col"));

require("antd/es/row/style/css");

var _row = _interopRequireDefault(require("antd/es/row"));

require("antd/es/cascader/style/css");

var _cascader = _interopRequireDefault(require("antd/es/cascader"));

require("antd/es/popover/style/css");

var _popover = _interopRequireDefault(require("antd/es/popover"));

require("antd/es/tooltip/style/css");

var _tooltip = _interopRequireDefault(require("antd/es/tooltip"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

require("antd/es/avatar/style/css");

var _avatar = _interopRequireDefault(require("antd/es/avatar"));

require("antd/es/menu/style/css");

var _menu = _interopRequireDefault(require("antd/es/menu"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/typography/style/css");

var _typography = _interopRequireDefault(require("antd/es/typography"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _comment = _interopRequireDefault(require("antd/lib/comment"));

var _dropdown = _interopRequireDefault(require("antd/lib/dropdown"));

var _icons = _interopRequireDefault(require("@ant-design/icons"));

var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));

var _ = _interopRequireWildcard(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _reselect = require("reselect");

var _uuid = _interopRequireDefault(require("uuid"));

var _SecureImage = _interopRequireDefault(require("../../../components/image/SecureImage"));

var _Util = require("../../../components/util/Util");

var _flags = require("../../../redux/flags/flags.types");

var _posts = require("../../../redux/posts/posts.types");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _Username = _interopRequireDefault(require("../../../components/username/Username"));

var _HMPTextArea = _interopRequireDefault(require("../../../components/textarea/HMPTextArea"));

var _comments = require("../../../redux/comments/comments.types");

require("./forumPage.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  confirm
} = _modal.default;
const {
  Paragraph
} = _typography.default;
const initialState = {
  posts: [],
  editedPost: undefined,
  allComments: [],
  allFlags: [],
  allThumbsups: [],
  allFavorites: [],
  avatars: [],
  topics: [],
  selectedStyle: undefined,
  isEditing: false,
  visibleFlagResolutionPopups: {
    post: [],
    comment: []
  },
  visibleActionMenus: {
    post: [],
    comment: []
  },
  visiblePostDateChangePopups: {
    post: [],
    comment: []
  },
  visibleAddCommentPopups: {
    post: [],
    comment: []
  },
  showTopicSelector: false,
  studyArms: [],
  studyId: -1,
  selectedParticipantId: -1,
  newCommentText: '',
  newDate: new Date()
};
var PostMode;
exports.PostMode = PostMode;

(function (PostMode) {
  PostMode[PostMode["FULL"] = 0] = "FULL";
  PostMode[PostMode["PARTIAL"] = 1] = "PARTIAL";
  PostMode[PostMode["EDIT"] = 2] = "EDIT";
})(PostMode || (exports.PostMode = PostMode = {}));

function filter(inputValue, path) {
  return path.some(option => option.label ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 : false);
}

class Post extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.capitalize = s => s ? s.split(' ').map(word => word[0].toUpperCase() + word.substring(1)).join(' ') : s;

    this.handleTitleChange = ({
      target: {
        value
      }
    }) => {
      this.setState((0, _immutabilityHelper.default)(this.state, {
        editedPost: {
          title: {
            $set: value
          }
        }
      }));
    };

    this.handleBodyChange = ({
      target: {
        value
      }
    }) => {
      this.setState((0, _immutabilityHelper.default)(this.state, {
        editedPost: {
          body: {
            $set: value
          }
        }
      }));
    };

    this.handleCancelPost = () => {
      this.setState({
        isEditing: false,
        editedPost: undefined
      });
    };

    this.getFlags = (type, typeId) => {
      return _.filter(this.props.allFlags, {
        typeId,
        type
      });
    };

    this.commentCount = (type, typeId) => {
      const comments = _.filter(this.props.allComments, {
        typeId,
        type
      });

      return comments ? comments.length : 0;
    };

    this.renderParticipantLink = (value, row) => {
      const {
        studyId
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: `/study/${studyId}/participants/${row.id}`
      }, value);
    };

    this.makeUsernamesHover = participants => {
      const {
        studyId
      } = this.props;
      const content = [];

      if (!participants.length || !participants[0]) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: (0, _uuid.default)()
        }, "none");
      }

      for (let i = 0; i < participants.length; i++) {
        const p = participants[i];

        if (!p) {
          return /*#__PURE__*/_react.default.createElement("div", null); // this is a temporary state with incompleted data, future render will resolve
        }

        content.push( /*#__PURE__*/_react.default.createElement("span", {
          key: p.id
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: `/study/${studyId}/participants/${p.id}/`
        }, p.username)));

        if (i !== participants.length - 1) {
          content.push( /*#__PURE__*/_react.default.createElement("br", {
            key: `${p.id}_br`
          }));
        }
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        key: (0, _uuid.default)()
      }, content);
    };

    this.commentHover = (type, typeId) => {
      const comments = _.filter(this.props.allComments, {
        typeId,
        type
      });

      const participants = _.uniqBy(_.map(comments, 'participant'), 'id');

      return this.makeUsernamesHover(participants);
    };

    this.thumbsupHover = (type, typeId) => {
      const thumbsups = _.filter(this.props.allThumbsups, {
        typeId,
        type
      });

      const participants = _.uniqBy(_.map(thumbsups, 'participant'), 'id');

      return this.makeUsernamesHover(participants);
    };

    this.thumbsupCount = (type, typeId) => {
      const thumbsups = _.filter(this.props.allThumbsups, {
        typeId,
        type
      });

      return thumbsups ? thumbsups.length : 0;
    };

    this.favoriteCount = (type, typeId) => {
      const favorites = _.filter(this.props.allFavorites, {
        typeId,
        type
      });

      return favorites ? favorites.length : 0;
    };

    this.favoriteHover = (type, typeId) => {
      const favorites = _.filter(this.props.allFavorites, {
        typeId,
        type
      });

      const participants = _.uniqBy(_.map(favorites, 'participant'), 'id');

      return this.makeUsernamesHover(participants);
    };

    this.postFavoriteCount = (type, typeId) => {
      const favorites = _.filter(this.props.allFavorites, {
        typeId,
        type
      });

      return favorites ? favorites.length : 0;
    };

    this.flagCount = (type, typeId) => {
      const flags = _.filter(this.props.allFlags, {
        typeId,
        type
      });

      return flags ? flags.length : 0;
    };

    this.flagHover = (type, typeId) => {
      const flags = _.filter(this.props.flags, {
        typeId,
        type
      });

      const participants = _.uniqBy(_.map(flags, 'participant'), 'id');

      return this.makeUsernamesHover(participants);
    };

    this.handleDelete = () => {
      const {
        post,
        deletePost
      } = this.props;

      if (post) {
        const {
          id
        } = post;
        confirm({
          title: 'Are you sure you want to delete this post?',
          okText: 'Delete',
          okType: 'danger',

          onOk() {
            deletePost(id);
          },

          onCancel() {}

        });
      }
    };

    this.iconFlagSolid = () => {
      return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proSolidSvgIcons.faFlag
      });
    };

    this.iconFlagOutline = () => {
      return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proRegularSvgIcons.faFlag
      });
    };

    this.iconThumbsupSolid = () => {
      return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proSolidSvgIcons.faThumbsUp
      });
    };

    this.iconThumbsupOutline = () => {
      return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proRegularSvgIcons.faThumbsUp
      });
    };

    this.iconFavoriteSolid = () => {
      return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proSolidSvgIcons.faStar
      });
    };

    this.iconFavoriteOutline = () => {
      return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proRegularSvgIcons.faStar
      });
    };

    this.iconCommentSolid = () => {
      return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proSolidSvgIcons.faCommentAltLines
      });
    };

    this.iconCommentOutline = () => {
      return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proRegularSvgIcons.faCommentAlt
      });
    };

    this.iconDelete = () => {
      return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proSolidSvgIcons.faTrashAlt
      });
    };

    this.iconElipsis = () => {
      return /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proSolidSvgIcons.faEllipsisH
      });
    };

    this.copyDeepLink = id => {
      const deepLink = `hmp://forum/${id}`;
      navigator.clipboard.writeText(deepLink).then(() => {
        _message2.default.success('Copied to clipboard!');
      }, () => {
        _message2.default.error('Failed to copy to clipboard.');
      });
    };

    this.handleSelectedParticipantChange = value => {
      this.setState({
        selectedParticipantId: parseInt(value[0])
      });
    };

    this.changePostPublishDate = date => {
      if (!date) {
        throw Error('No date during date change. how did this happen?');
      }

      this.setState({
        newDate: date.toDate()
      });
    };

    this.unselectablePostPublishDate = date => {
      return (0, _moment.default)().isSameOrAfter(date);
    };

    this.changeCommentCreateDate = comment => date => {
      const {
        updateComment
      } = this.props;

      if (!date) {
        throw Error('No date during date change. how did this happen?');
      } else if (!comment) {
        throw Error('No post during date change. how did this happen?');
      } else {
        comment.createDate = date.toDate();
        updateComment(comment);
        this.handlePostDateChangePopupVisibleChange(false, 'comment', comment.id);
      }
    };

    this.handleDateChangeOk = (type, typeId) => e => {
      const {
        post,
        allComments,
        savePost,
        updateComment
      } = this.props;
      const {
        newDate
      } = this.state;

      if (type === 'post' && post) {
        const updatedPost = _.clone(post);

        updatedPost.publishDate = newDate;
        savePost(updatedPost);
      } else {
        const updatedComment = _.find(allComments, c => c.id === typeId);

        updatedComment.createDate = newDate;
        updateComment(updatedComment);
      }

      this.handlePostDateChangePopupVisibleChange(false, type, typeId);
    };

    this.renderPostItemHeader = post => {
      var _a, _b, _c, _d;

      const {
        mode,
        topics,
        studyArms,
        savePost
      } = this.props;
      const {
        newDate,
        showTopicSelector
      } = this.state;

      const menuClick = event => {
        post.topicId = event.key;
        this.props.savePost(post);
        this.setState({
          showTopicSelector: false
        });
      };

      const currentTopic = _.find(topics, t => t.id == post.topicId);

      const postStudyArm = _.find(studyArms, sa => post.studyArmId === sa.id);

      if (!currentTopic || !postStudyArm) return /*#__PURE__*/_react.default.createElement("div", null);

      const topicsInSameCollection = _.filter(topics, t => t.topicCollectionId === currentTopic.topicCollectionId);

      const menu = /*#__PURE__*/_react.default.createElement(_menu.default, {
        onClick: menuClick
      }, _.map(topicsInSameCollection, topic => {
        return /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
          key: topic.id
        }, /*#__PURE__*/_react.default.createElement("a", null, topic.title));
      }));

      const avatarObj = ((_a = post === null || post === void 0 ? void 0 : post.participant) === null || _a === void 0 ? void 0 : _a.avatarId) ? this.getAvatar((_b = post.participant) === null || _b === void 0 ? void 0 : _b.avatarId) : undefined;
      const avatar = avatarObj ? /*#__PURE__*/_react.default.createElement(_avatar.default, {
        src: avatarObj.avatar,
        style: {
          backgroundColor: `#${(_c = post === null || post === void 0 ? void 0 : post.participant) === null || _c === void 0 ? void 0 : _c.avatarBackground}`
        }
      }) : undefined;
      const redFlagCssStyle = this.hasUnresolvedFlags('post', post.id) ? 'red-flag' : '';
      const tags = [];

      if (post.deleteDate !== null) {
        tags.push( /*#__PURE__*/_react.default.createElement("span", {
          key: "deleted",
          title: (0, _moment.default)(post.deleteDate).calendar(),
          className: "post-tag-bubble deleted"
        }, "DELETED"));
      }

      if (post.isHidden) {
        tags.push( /*#__PURE__*/_react.default.createElement("span", {
          key: "hidden",
          title: "hidden",
          className: "post-tag-bubble hidden"
        }, "HIDDEN"));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        id: "post-header-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "title-container"
      }, /*#__PURE__*/_react.default.createElement("p", {
        id: "title",
        className: "title-truncate"
      }, post.title), /*#__PURE__*/_react.default.createElement("div", {
        className: "title-extra"
      }, /*#__PURE__*/_react.default.createElement("a", {
        title: "Copy deep link to clipboard",
        className: "forum-post-link",
        onClick: e => {
          e.stopPropagation();
          this.copyDeepLink(post.id);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "far fa-link fa-sm"
      })), tags)), /*#__PURE__*/_react.default.createElement("span", {
        id: "arm",
        className: "small-font"
      }, (0, _Util.getStudyArmLabelFromId)(studyArms, post.studyArmId)), /*#__PURE__*/_react.default.createElement("div", {
        id: "after-title-container"
      }, /*#__PURE__*/_react.default.createElement("span", {
        id: "avatar"
      }, avatar), /*#__PURE__*/_react.default.createElement("p", {
        id: "username",
        className: "small-font"
      }, /*#__PURE__*/_react.default.createElement(_Username.default, {
        participantId: (_d = post.participant) === null || _d === void 0 ? void 0 : _d.id
      })), /*#__PURE__*/_react.default.createElement("hr", {
        id: "horizontal-rule"
      }), /*#__PURE__*/_react.default.createElement(_modal.default, {
        title: "Change Post Date",
        visible: this.isPostDateChangePopupVisible('post', post.id),
        destroyOnClose: true,
        okText: "Save",
        onOk: this.handleDateChangeOk('post', post.id),
        onCancel: () => this.handlePostDateChangePopupVisibleChange(false, 'post', post.id)
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: "date-change-modal-content"
      }, "Date of Post:", /*#__PURE__*/_react.default.createElement("span", {
        id: "date-picker-container"
      }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
        id: "date-picker",
        defaultValue: (0, _moment.default)(newDate),
        showTime: true,
        disabledDate: this.unselectablePostPublishDate,
        allowClear: false,
        onChange: this.changePostPublishDate
      })))), /*#__PURE__*/_react.default.createElement("p", {
        id: "publish-date",
        className: `small-font ${(0, _moment.default)(post.publishDate).isAfter((0, _moment.default)()) && 'post-tag-bubble unpublished'}`
      }, (0, _Util.renderDateWithTime)(post.publishDate)), /*#__PURE__*/_react.default.createElement(_modal.default, {
        title: "Change Topic",
        visible: showTopicSelector.valueOf()
      }, /*#__PURE__*/_react.default.createElement(_dropdown.default, {
        overlay: menu,
        placement: "bottomLeft"
      }, /*#__PURE__*/_react.default.createElement(_button.default, null, post.topic))), /*#__PURE__*/_react.default.createElement("p", {
        id: "category",
        className: "small-font"
      }, post.topic), /*#__PURE__*/_react.default.createElement("div", {
        id: "social-container"
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "bottom",
        title: this.flagHover('post', post.id)
      }, /*#__PURE__*/_react.default.createElement(_popover.default, {
        content: this.flagStatsMenu('post', post),
        title: "Resolve Flag",
        trigger: "click",
        // @ts-ignore
        visible: this.isFlagResolutionPopupVisible('post', post.id),
        onVisibleChange: visible => this.handleFlagResolutionPopupVisibleChange(visible, 'post', post.id)
      }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("span", {
        className: `${redFlagCssStyle}`
      }, this.flagCount('post', post.id), ' ', /*#__PURE__*/_react.default.createElement(_icons.default, {
        style: {
          color: '#8185B3',
          marginRight: 15
        },
        component: this.iconFlagOutline
      }))))), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "bottom",
        title: this.commentHover('post', post.id)
      }, /*#__PURE__*/_react.default.createElement(_modal.default, {
        title: "Add Comment",
        visible: this.isAddCommentPopupVisible('post', post.id),
        destroyOnClose: true,
        onOk: this.handleAddCommentSave('post', post),
        onCancel: () => this.handleAddCommentPopupVisibleChange(false, 'post', post.id)
      }, this.createCommentMenu('post', post)), this.commentCount('post', post.id).toString(), ' ', /*#__PURE__*/_react.default.createElement(_icons.default, {
        style: {
          color: '#8185B3',
          marginRight: '10px'
        },
        component: this.iconCommentOutline
      })), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "bottom",
        title: this.thumbsupHover('post', post.id)
      }, ' ', this.thumbsupCount('post', post.id).toString(), ' ', /*#__PURE__*/_react.default.createElement(_icons.default, {
        style: {
          color: '#8185B3',
          marginRight: '8px'
        },
        component: this.iconThumbsupOutline
      }), ' '), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "bottom",
        title: this.favoriteHover('post', post.id)
      }, ' ', this.favoriteCount('post', post.id).toString(), ' ', /*#__PURE__*/_react.default.createElement(_icons.default, {
        style: {
          color: '#8185B3',
          marginRight: '8px'
        },
        component: this.iconFavoriteOutline
      }), ' '), mode === PostMode.FULL && /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "bottom",
        title: "Actions"
      }, /*#__PURE__*/_react.default.createElement(_popover.default, {
        content: this.createActionMenu('post', post),
        title: "Action Menu",
        trigger: "click",
        visible: this.isActionMenuVisible('post', post.id),
        onVisibleChange: visible => this.handleActionMenuVisibleChange(visible, 'post', post.id)
      }, /*#__PURE__*/_react.default.createElement(_icons.default, {
        style: {
          color: '#8185B3',
          marginRight: '10px'
        },
        component: this.iconElipsis
      }))))));
    };

    this.getAvatar = avatarId => {
      return _.find(this.props.avatars, a => a.id === avatarId);
    };

    this.hasUnresolvedFlags = (type, typeId) => {
      const flags = this.getFlags(type, typeId);
      return _.find(flags, f => !f.resolution);
    };

    this.resolveFlags = (type, typeId, resolution) => {
      const flags = this.getFlags(type, typeId);

      if (flags === null || flags === void 0 ? void 0 : flags.length) {
        const ids = _.map(flags, 'id');

        this.props.resolveFlags({
          ids,
          resolution
        });
      }
    };

    this.hideContent = (type, typeId) => {
      this.props.hideContent({
        type,
        typeId
      });
      this.resolveFlags(type, typeId, 'confirmed');
    };

    this.unhideContent = (type, typeId) => {
      this.props.unhideContent({
        type,
        typeId
      });
    };

    this.onCommentTextChange = e => {
      // @ts-ignore
      this.setState({
        newCommentText: e.target.value
      });
    };

    this.createActionMenu = (type, postOrComment) => {
      var _a;

      const {
        post,
        studyArms,
        forumPostDateMutableEnabled
      } = this.props;
      const flagCount = this.flagCount(type, postOrComment.id);

      const postStudyArm = _.find(studyArms, sa => (post === null || post === void 0 ? void 0 : post.studyArmId) === sa.id);

      const actionMenuSelect = e => {
        switch (e.key) {
          case 'changePostDate':
            this.handlePostDateChangePopupVisibleChange(true, type, postOrComment.id);
            break;

          case 'addComment':
            this.handleAddCommentPopupVisibleChange(true, type, postOrComment.id);
            break;

          case 'hideContent':
            this.hideContent(type, postOrComment.id);
            break;

          case 'unhideContent':
            this.unhideContent(type, postOrComment.id);
            break;

          case 'viewFlagStats':
            this.handleFlagResolutionPopupVisibleChange(true, type, postOrComment.id);
            break;

          case 'ignoreFlags':
            this.resolveFlags(type, postOrComment.id, 'ignored');
            break;

          case 'changeTopic':
            this.setState({
              showTopicSelector: true
            });
            break;

          case 'deletePost':
            this.handleDelete();
            break;
        }

        this.handleActionMenuVisibleChange(false, type, postOrComment.id);
      };

      return /*#__PURE__*/_react.default.createElement(_menu.default, {
        onClick: actionMenuSelect
      }, type === 'post' && forumPostDateMutableEnabled && /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "changePostDate"
      }, `Change ${this.capitalize(type)} Date`), (type === 'post' || !postOrComment.parentCommentId) && /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "addComment"
      }, "Add Comment"), type === 'post' && /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "deletePost"
      }, "Delete Post"), postOrComment.isHidden ? /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "unhideContent"
      }, "Unhide Content") : /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "hideContent"
      }, "Hide Content"), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "viewFlagStats"
      }, `View ${(_a = postOrComment.participant) === null || _a === void 0 ? void 0 : _a.username}'s Flag Stats`), !!flagCount && /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "ignoreFlags"
      }, "Ignore Flags"), /*#__PURE__*/_react.default.createElement(_menu.default.Item, {
        key: "changeTopic"
      }, "Change Topic"));
    };

    this.createCommentMenu = (type, postOrComment) => {
      const {
        hasCareNavigatorRole,
        pseudoParticipants,
        participants,
        allComments
      } = this.props;
      const {
        newCommentText,
        newDate
      } = this.state;

      if (!participants || pseudoParticipants && pseudoParticipants.length && !pseudoParticipants[0]) {
        return /*#__PURE__*/_react.default.createElement("div", null); // this is a temporary state with incomplete data, future render will resolve
      }

      const pseudosThisArm = _.filter(pseudoParticipants, p => !!p.username && p.studyArmId === postOrComment.studyArmId);

      if (!(pseudosThisArm === null || pseudosThisArm === void 0 ? void 0 : pseudosThisArm.length) && !hasCareNavigatorRole) {
        return /*#__PURE__*/_react.default.createElement("div", null, "There are no pseudo participants associated with your account");
      }

      let participantSelectorOptions = [];

      if (hasCareNavigatorRole) {
        participantSelectorOptions = _.map(_.filter(participants, p => !!p.username && p.studyArmId === postOrComment.studyArmId && p.type === 'PSEUDO PARTICIPANT'), participant => {
          return {
            label: participant.username,
            value: participant.id.toString()
          };
        });
      } else if (pseudosThisArm.length > 1) {
        participantSelectorOptions = _.map(pseudosThisArm, participant => {
          return {
            label: participant.username,
            value: participant.id.toString()
          };
        });
      }

      let parentDate;

      if (type === 'comment') {
        if (postOrComment.parentCommentId) {
          parentDate = (0, _moment.default)(_.find(allComments, c => c.id === c.parentCommentId).createDate);
        } else {
          parentDate = (0, _moment.default)(postOrComment.createDate);
        }
      } else {
        parentDate = (0, _moment.default)(postOrComment.publishDate);
      }

      const unselectableCommentDate = date => {
        return parentDate.isSameOrAfter(date);
      };

      return /*#__PURE__*/_react.default.createElement("div", {
        id: "create-comment-popover"
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: "button-row"
      }, /*#__PURE__*/_react.default.createElement("p", null, "Add As"), hasCareNavigatorRole || pseudosThisArm.length > 1 ? /*#__PURE__*/_react.default.createElement(_cascader.default, {
        placeholder: "Enter participant's username",
        options: participantSelectorOptions,
        // @ts-ignore
        onChange: this.handleSelectedParticipantChange,
        showSearch: {
          filter
        }
      }) : /*#__PURE__*/_react.default.createElement("p", {
        id: "add-as-username"
      }, pseudosThisArm[0].username)), /*#__PURE__*/_react.default.createElement(_HMPTextArea.default, {
        style: {
          width: '450px',
          marginBottom: '15px'
        },
        value: newCommentText,
        minRows: 15,
        // @ts-ignore
        onChange: this.onCommentTextChange,
        spellCheck: true,
        placeholder: "Enter your comment"
      }), "Date of Comment:", /*#__PURE__*/_react.default.createElement("span", {
        id: "date-picker-container"
      }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
        id: "date-picker",
        defaultValue: (0, _moment.default)(newDate),
        disabledDate: unselectableCommentDate,
        showTime: true,
        allowClear: false,
        onChange: this.changePostPublishDate
      })));
    };

    this.handleAddCommentSave = (type, postOrComment) => e => {
      const {
        post,
        pseudoParticipants,
        createComment
      } = this.props;
      const {
        newCommentText,
        selectedParticipantId,
        newDate
      } = this.state;

      const pseudosThisArm = _.filter(pseudoParticipants, p => !!p.username && p.studyArmId === postOrComment.studyArmId);

      const typeId = type === 'comment' ? post.id : postOrComment.id;
      const parentCommentId = type === 'comment' ? postOrComment.id : undefined;
      const participantId = selectedParticipantId !== -1 ? selectedParticipantId : pseudosThisArm[0].id;
      createComment({
        type: 'post',
        typeId,
        comment: newCommentText,
        createDate: newDate,
        parentCommentId,
        participantId
      });
      this.setState({
        newCommentText: '',
        selectedParticipantId: -1
      });
      this.handleAddCommentPopupVisibleChange(false, type, typeId);
    };

    this.flagStatsMenu = (type, postOrComment) => {
      var _a;

      const {
        flags,
        posts,
        allComments,
        studyId
      } = this.props;

      const theirPosts = _.filter(posts, p => {
        var _a;

        return p.createdByParticipantId === ((_a = postOrComment.participant) === null || _a === void 0 ? void 0 : _a.id);
      });

      const theirFlaggedPosts = _.filter(theirPosts, p => _.find(flags, f => f.flaggedParticipantId === p.createdByParticipantId));

      const theirHiddenPosts = _.filter(theirPosts, p => p.isHidden);

      const theirComments = _.filter(allComments, c => {
        var _a;

        return c.participantId === ((_a = postOrComment.participant) === null || _a === void 0 ? void 0 : _a.id);
      });

      const theirFlaggedComments = _.filter(theirComments, c => _.find(flags, f => f.flaggedParticipantId === c.participantId));

      const theirHiddenComments = _.filter(theirComments, c => c.isHidden);

      return /*#__PURE__*/_react.default.createElement("div", {
        id: "flag-stats-popover"
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: "title-row"
      }, /*#__PURE__*/_react.default.createElement("p", null, (_a = postOrComment.participant) === null || _a === void 0 ? void 0 : _a.username, "'s Flag Stats")), /*#__PURE__*/_react.default.createElement("div", {
        id: "table-row"
      }, /*#__PURE__*/_react.default.createElement("table", {
        id: "table"
      }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", {
        className: "center"
      }, "flagged"), /*#__PURE__*/_react.default.createElement("th", {
        className: "center"
      }, "hidden"))), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Posts"), /*#__PURE__*/_react.default.createElement("td", null, theirPosts.length), /*#__PURE__*/_react.default.createElement("td", {
        className: "center"
      }, theirFlaggedPosts.length), /*#__PURE__*/_react.default.createElement("td", {
        className: "center"
      }, theirHiddenPosts.length)), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, "Comments"), /*#__PURE__*/_react.default.createElement("td", null, theirComments.length), /*#__PURE__*/_react.default.createElement("td", {
        className: "center"
      }, theirFlaggedComments.length), /*#__PURE__*/_react.default.createElement("td", {
        className: "center"
      }, theirHiddenComments.length)), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
        className: "bottom-row"
      }), /*#__PURE__*/_react.default.createElement("td", {
        className: "bottom-row"
      }, theirPosts.length + theirComments.length), /*#__PURE__*/_react.default.createElement("td", {
        className: "center bottom-row"
      }, theirFlaggedPosts.length + theirFlaggedComments.length), /*#__PURE__*/_react.default.createElement("td", {
        className: "center bottom-row"
      }, theirHiddenPosts.length + theirHiddenComments.length))))));
    };

    this.renderCommentActions = comment => {
      const {
        studyArms,
        post,
        forumPostDateMutableEnabled
      } = this.props;

      const postStudyArm = _.find(studyArms, sa => (post === null || post === void 0 ? void 0 : post.studyArmId) === sa.id);

      return [/*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "bottom",
        title: this.flagHover('comment', comment.id)
      }, /*#__PURE__*/_react.default.createElement(_popover.default, {
        content: this.flagStatsMenu('comment', comment),
        title: "Resolve Flag",
        trigger: "click",
        // @ts-ignore
        visible: this.isFlagResolutionPopupVisible('comment', comment.id),
        onVisibleChange: visible => this.handleFlagResolutionPopupVisibleChange(visible, 'comment', comment.id)
      }, this.flagCount('comment', comment.id).toString(), ' ', /*#__PURE__*/_react.default.createElement(_icons.default, {
        style: {
          color: '#8185B3',
          marginRight: 15
        },
        component: this.iconFlagOutline
      }))), ...(comment.parentCommentId ? [] : [/*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "bottom",
        title: this.commentHover('post', comment.id)
      }, /*#__PURE__*/_react.default.createElement(_modal.default, {
        title: "Add Comment",
        visible: this.isAddCommentPopupVisible('comment', comment.id),
        destroyOnClose: true,
        onOk: this.handleAddCommentSave('comment', comment),
        onCancel: () => this.handleAddCommentPopupVisibleChange(false, 'comment', comment.id)
      }, this.createCommentMenu('comment', comment)), this.commentCount('comment', comment.id).toString(), ' ', /*#__PURE__*/_react.default.createElement(_icons.default, {
        style: {
          color: '#8185B3',
          marginRight: '10px'
        },
        component: this.iconCommentOutline
      }))]), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "bottom",
        title: this.thumbsupHover('comment', comment.id)
      }, this.thumbsupCount('comment', comment.id).toString(), ' ', /*#__PURE__*/_react.default.createElement(_icons.default, {
        style: {
          color: '#8185B3',
          marginRight: 15
        },
        component: this.iconThumbsupOutline
      })), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "bottom",
        title: this.favoriteHover('comment', comment.id)
      }, this.favoriteCount('comment', comment.id).toString(), ' ', /*#__PURE__*/_react.default.createElement(_icons.default, {
        style: {
          color: '#8185B3',
          marginRight: 15
        },
        component: this.iconFavoriteOutline
      })), ...(forumPostDateMutableEnabled ? [/*#__PURE__*/_react.default.createElement(_popover.default, {
        content: this.createActionMenu('comment', comment),
        title: "Action Menu",
        trigger: "click",
        visible: this.isActionMenuVisible('comment', comment.id),
        onVisibleChange: visible => this.handleActionMenuVisibleChange(visible, 'comment', comment.id)
      }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        placement: "bottom",
        title: "Actions"
      }, /*#__PURE__*/_react.default.createElement(_icons.default, {
        style: {
          color: '#8185B3',
          marginRight: '10px'
        },
        component: this.iconElipsis
      })))] : [])];
    };

    this.renderCommentsSection = post => {
      const {
        allComments,
        studyId
      } = this.props;
      const {
        newDate
      } = this.state;

      const postComments = _.filter(allComments, {
        type: 'post',
        typeId: post.id
      });

      const sortedComments = _.reverse(_.sortBy(postComments, 'createDate')); // delete any existing replies


      _.forEach(sortedComments, c => delete c.replies); // order the comments by created date with the most recent at the top


      const orderedComments = _.reduceRight(sortedComments, (arr, comment) => {
        if (comment.parentCommentId) {
          const parentComment = _.find(allComments, c => c.id === comment.parentCommentId);

          if (!parentComment.replies) {
            parentComment.replies = [];
          }

          parentComment.replies.splice(0, 0, comment);
        } else {
          arr.splice(0, 0, comment);
        }

        return arr;
      }, []);

      const renderContent = comment => {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: `body-${comment.id}`
        }, comment.body);
      };

      const renderComments = comments => {
        return /*#__PURE__*/_react.default.createElement("div", null, _.map(comments, comment => {
          var _a, _b, _c;

          const commentThumbsUpCount = this.thumbsupCount('comment', comment.id);
          const avatarObject = ((_a = comment.participant) === null || _a === void 0 ? void 0 : _a.avatarId) ? this.getAvatar(comment.participant.avatarId) : undefined;

          const avatar = /*#__PURE__*/_react.default.createElement(_avatar.default, {
            src: avatarObject === null || avatarObject === void 0 ? void 0 : avatarObject.avatar,
            style: {
              backgroundColor: `#${(_b = comment.participant) === null || _b === void 0 ? void 0 : _b.avatarBackground}`
            }
          });

          let parentDate;

          if (comment.parentCommentId) {
            parentDate = (0, _moment.default)(_.find(allComments, c => c.id === comment.parentCommentId).createDate);
          } else {
            parentDate = (0, _moment.default)(post.publishDate);
          }

          const unselectableCommentDate = date => {
            return parentDate.isSameOrAfter(date);
          };

          const tags = [];

          if (comment.isHidden) {
            tags.push( /*#__PURE__*/_react.default.createElement("span", {
              key: `hidden-bubble-${comment.id}`,
              title: "hidden",
              className: "post-tag-bubble hidden"
            }, "HIDDEN"));
          }

          return /*#__PURE__*/_react.default.createElement("span", {
            key: `comment-span-${comment.id}`
          }, /*#__PURE__*/_react.default.createElement(_comment.default, {
            key: `comment-${comment.id}`,
            avatar: avatar,
            author: /*#__PURE__*/_react.default.createElement("span", {
              style: {
                color: '#ccc'
              }
            }, /*#__PURE__*/_react.default.createElement("a", {
              key: `a-${comment.id}`,
              href: `/study/${studyId}/participants/${(_c = comment.participant) === null || _c === void 0 ? void 0 : _c.id}/`
            }, comment.username), tags),
            content: renderContent(comment),
            datetime: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_modal.default, {
              title: "Change Comment Date",
              visible: this.isPostDateChangePopupVisible('comment', comment.id),
              onOk: this.handleDateChangeOk('comment', comment.id),
              okText: "Save",
              destroyOnClose: true,
              onCancel: () => this.handlePostDateChangePopupVisibleChange(false, 'comment', comment.id)
            }, /*#__PURE__*/_react.default.createElement("div", {
              id: "date-change-modal-content"
            }, "Date of Comment:", /*#__PURE__*/_react.default.createElement("span", {
              id: "date-picker-container"
            }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
              id: "date-picker",
              defaultValue: (0, _moment.default)(newDate),
              showTime: true,
              disabledDate: unselectableCommentDate,
              allowClear: false,
              onChange: this.changePostPublishDate
            })))), /*#__PURE__*/_react.default.createElement("p", {
              id: "comment-publish-date",
              className: `small-font ${(0, _moment.default)(comment.createDate).isAfter((0, _moment.default)()) && 'post-tag-bubble unpublished'}`
            }, (0, _Util.renderDateWithTime)(comment.createDate))),
            actions: this.renderCommentActions(comment)
          }, renderComments(comment.replies)));
        }));
      };

      return renderComments(orderedComments);
    };

    this.isFlagResolutionPopupVisible = (type, typeId) => {
      const {
        visibleFlagResolutionPopups
      } = this.state;
      return visibleFlagResolutionPopups[type].indexOf(typeId) !== -1;
    };

    this.isPostDateChangePopupVisible = (type, typeId) => {
      const {
        visiblePostDateChangePopups
      } = this.state;
      return visiblePostDateChangePopups[type].indexOf(typeId) !== -1;
    };

    this.handleFlagResolutionPopupVisibleChange = (visible, type, typeId) => {
      const updated = _.cloneDeep(this.state.visibleFlagResolutionPopups);

      if (visible) {
        updated[type].push(typeId);
      } else {
        updated[type] = _.without(updated[type], typeId);
      }

      this.setState({
        visibleFlagResolutionPopups: updated
      });
    };

    this.handlePostDateChangePopupVisibleChange = (visible, type, typeId) => {
      const {
        post,
        allComments
      } = this.props;
      let newDate;

      if (type === 'post') {
        newDate = post.publishDate;
      } else {
        const comment = _.find(allComments, c => c.id === typeId);

        newDate = comment.createDate;
      }

      const updated = _.cloneDeep(this.state.visiblePostDateChangePopups);

      if (visible) {
        updated[type].push(typeId);
      } else {
        updated[type] = _.without(updated[type], typeId);
      }

      this.setState({
        visiblePostDateChangePopups: updated,
        newDate
      });
    };

    this.isAddCommentPopupVisible = (type, typeId) => {
      const {
        visibleAddCommentPopups
      } = this.state;
      return visibleAddCommentPopups[type].indexOf(typeId) !== -1;
    };

    this.isActionMenuVisible = (type, typeId) => {
      const {
        visibleActionMenus
      } = this.state;
      return visibleActionMenus[type].indexOf(typeId) !== -1;
    };

    this.handleAddCommentPopupVisibleChange = (visible, type, typeId) => {
      const updated = _.cloneDeep(this.state.visibleAddCommentPopups);

      if (visible) {
        updated[type].push(typeId);
      } else {
        updated[type] = _.without(updated[type], typeId);
      }

      this.setState({
        visibleAddCommentPopups: updated
      });
    };

    this.handleActionMenuVisibleChange = (visible, type, typeId) => {
      const updated = _.cloneDeep(this.state.visibleActionMenus);

      if (visible) {
        updated[type].push(typeId);
      } else {
        updated[type] = _.without(updated[type], typeId);
      }

      this.setState({
        visibleActionMenus: updated
      });
    };
  }

  render() {
    var _a;

    const {
      post,
      selectedStyle,
      mode,
      participants
    } = this.props;
    if (!post || !participants) return /*#__PURE__*/_react.default.createElement("div", null, "error");
    const avatar = ((_a = post.participant) === null || _a === void 0 ? void 0 : _a.avatarId) ? this.getAvatar(post.participant.avatarId) : undefined;
    const fadeCssClass = PostMode.PARTIAL === mode ? 'three-line-fade' : '';
    const mediaCssClass = PostMode.PARTIAL === mode ? 'body-media-partial' : '';
    const alertBoxCss = post.isHidden ? 'alert-box' : '';
    let body;

    if (post.poll) {
      const onelinefade = PostMode.PARTIAL === mode ? 'one-line-fade' : '';
      const options = PostMode.PARTIAL === mode ? _.slice(post.poll.options, 0, 2) : post.poll.options;
      body = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
        id: "body-text",
        className: `${onelinefade}`
      }, post.body), /*#__PURE__*/_react.default.createElement("div", {
        className: `${PostMode.PARTIAL === mode && 'poll-body-options'}`
      }, _.map(options, item => {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: item.option
        }, ' ', item.option, ": ", item.count, /*#__PURE__*/_react.default.createElement("br", null));
      }), options.length === post.poll.options.length ? undefined : /*#__PURE__*/_react.default.createElement("span", null, " ", post.poll.options.length - options.length, " more ")));
    } else if (post.postLinks) {
      // there can only be one entry in the array postLinks per the current design
      const postLink = post.postLinks[0];

      if (postLink.type === 'web') {
        body = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
          id: "body-text",
          className: `${fadeCssClass}`
        }, post.body), /*#__PURE__*/_react.default.createElement("a", {
          href: postLink.url
        }, postLink.url));
      } else if (postLink.type === 'image') {
        // const url = _.replace(postLink.url, 'https://hmpweb-dev.med.unc.edu/api/c/', 'http://localhost:3001/api/a/') + `?participantId=${post.createdByParticipantId}`;
        const url = `${_.replace(postLink.url, '/c/upload/', '/a/upload/')}?participantId=${post.createdByParticipantId}`;
        body = /*#__PURE__*/_react.default.createElement("div", {
          id: "body-media",
          className: `${mediaCssClass}`
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            height: '100%',
            maxWidth: '50%'
          },
          className: `${alertBoxCss}`
        }, /*#__PURE__*/_react.default.createElement(_SecureImage.default, {
          url: url
        })), /*#__PURE__*/_react.default.createElement("p", {
          id: "body-text",
          className: `${fadeCssClass}`
        }, post.body));
      } else if (postLink.type === 'video') {
        const url = _.replace(postLink.url, 'https://youtu.be/', 'https://www.youtube.com/embed/'); // @ts-ignore


        body = /*#__PURE__*/_react.default.createElement("div", {
          id: "body-media"
        }, /*#__PURE__*/_react.default.createElement("div", {
          id: "ytContainer",
          className: `${PostMode.PARTIAL === mode ? 'partial-container' : 'full-container'}`
        }, /*#__PURE__*/_react.default.createElement("iframe", {
          id: "ytplayer",
          className: `${PostMode.PARTIAL === mode ? 'partial-player' : 'full-player'}`,
          type: "text/html",
          src: url,
          frameBorder: "0"
        })), /*#__PURE__*/_react.default.createElement("p", {
          id: "body-text",
          className: `${fadeCssClass}`
        }, post.body));
      } else {
        body = /*#__PURE__*/_react.default.createElement("p", null, "Unhandled Post Link Type:", postLink.type);
      }
    } else {
      body = /*#__PURE__*/_react.default.createElement("p", {
        id: "body-text",
        className: `${fadeCssClass}`
      }, post.body);
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      id: "post-container",
      key: post.id,
      style: { ...selectedStyle
      }
    }, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 24
    }, this.renderPostItemHeader(post))), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 24
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: "post-body-container"
    }, body))), /*#__PURE__*/_react.default.createElement(_col.default, {
      span: 24
    }, /*#__PURE__*/_react.default.createElement("div", null, this.props.mode === PostMode.FULL ? this.renderCommentsSection(post) : /*#__PURE__*/_react.default.createElement("div", null))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  hasCareNavigatorRole: selectors.hasCareNavigatorRole,
  pseudoParticipants: selectors.getCurrentUserPseudoParticipants,
  participants: selectors.getParticipants,
  posts: selectors.getPosts,
  allComments: selectors.getComments,
  allFlags: selectors.getFlags,
  allFavorites: selectors.getFavorites,
  allThumbsups: selectors.getThumbsups,
  avatars: selectors.getAvatars,
  topics: selectors.getFlattenedForumTopics,
  studyArms: selectors.getStudyArms,
  studyId: selectors.getRequestedStudyId,
  forumPostDateMutableEnabled: selectors.getForumPostDateMutableEnabled
});

const mapDispatchToProps = dispatch => {
  return {
    resolveFlags: flagResolution => dispatch(_flags.resolveFlagsAsync.request(flagResolution)),
    hideContent: payload => dispatch(_flags.hideContentAsync.request(payload)),
    unhideContent: payload => dispatch(_flags.unhideContentAsync.request(payload)),
    savePost: post => dispatch(_posts.savePostAsync.request(post)),
    deletePost: id => dispatch(_posts.deletePostAsync.request(id)),
    createComment: param => dispatch(_comments.createCommentAsync.request(param)),
    updateComment: param => dispatch(_comments.updateCommentAsync.request(param))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Post);

exports.default = _default;